var React = require('react');

function Inbox (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"43.0016","cy":"43.0001","r":"34.4","fill":"#EBF0FF","key":0}),React.createElement("path",{"d":"M25.7969 35.8996L39.7411 28.4091C41.7742 27.3169 44.2195 27.3169 46.2527 28.4091L60.1969 35.8996M25.7969 35.8996V56.7602M25.7969 35.8996L35.2569 42.1402M25.7969 56.7602H60.1969M25.7969 56.7602L35.2569 42.1402M60.1969 56.7602V35.8996M60.1969 56.7602L50.7369 42.1402M60.1969 35.8996L50.7369 42.1402M35.2569 42.1402L39.6557 44.5839C41.7336 45.7383 44.2602 45.7383 46.3381 44.5839L50.7369 42.1402","stroke":"#6366F1","strokeWidth":"3.44","key":1})]);
}

Inbox.defaultProps = {"width":"80","height":"80","viewBox":"0 0 80 80","fill":"none"};

module.exports = Inbox;

Inbox.default = Inbox;
